import { to } from 'helpers/Async';
import {
  EVENT_ACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS,
  EVENTS_INTERACTIONS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { CATEGORIES, LABELS } from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';
import MembershipService from 'modules/membership/MembershipService';
import { EVENTS } from 'modules/membershipEvent/constants';
import { UiService } from 'modules/ui';
import { UserService } from 'modules/user';

import { SPARKLE_SUPPORTED_LOCALES } from './constants';

import CampaignManagerService from '../CampaignManager.service';

import Request from '@hotmart/request';

const events = GtagService.createEvents({
  common: {
    name: 'sparkle-campaign-modal-producer',
    category: CATEGORIES.SPARKLE_CAMPAIGN
  },
  accepted: {
    action: 'modal-activate',
    label: LABELS.ACCEPTED
  },
  refused: {
    action: 'modal-activate',
    label: LABELS.REFUSED
  },
  play: {
    action: 'modal-video-play'
  }
});

const dismissSparkleCampaignEvent = async () => {
  const [error, response] = await to(
    CampaignManagerService.dismiss(EVENTS.SPARKLE_CAMPAIGN)
  );

  return [error, response];
};

const updateCampaignStatus = async ({ status }) => {
  let [error, response] = await to(
    Request('config.updateSparkleCampaignStatus', { active: status })
  );

  if (error) {
    UiService.handleError(error);
    return [error, response];
  }

  MembershipService.setSparkleCommunicationStatus(status);

  [error, response] = await to(dismissSparkleCampaignEvent());

  if (error) {
    return [error, response];
  }

  const event = status ? events.accepted : events.refused;

  GtagService.send(event);

  DatahubService.sendEvent({
    action: 'interact',
    event: buildInteractionEventData({
      category: EVENTS_CATEGORY.SPARKLE_CAMPAIGN.NAME,
      label: status
        ? EVENTS_LABELS.SPARKLE_CAMPAIGN.TOGGLE_ON
        : EVENTS_LABELS.SPARKLE_CAMPAIGN.TOGGLE_OFF,
      action: EVENTS_INTERACTIONS.CLICK
    })
  });

  UiService.setAlertSuccess('done');

  return [error, response];
};

const sendPlayEvent = () => {
  GtagService.send(events.play);

  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category:
        EVENTS_CATEGORY.SPARKLE_CAMPAIGN.SPARKLE_CAMPAIGN_MODAL_PRODUCER,
      label: EVENTS_LABELS.SPARKLE_CAMPAIGN.MODAL_VIDEO_PLAYER,
      action: EVENTS_INTERACTIONS.PLAY_VIDEO_MODAL
    })
  });
};

const hasLocaleSupport = () => {
  const formatLocale = (locale) =>
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    locale.substring(0, 2).toUpperCase();
  const userLocale = formatLocale(UserService.language);

  return SPARKLE_SUPPORTED_LOCALES.map(formatLocale).includes(userLocale);
};

export default {
  enableCommunication: () => updateCampaignStatus({ status: true }),
  disableCommunication: () => updateCampaignStatus({ status: false }),
  dismissEvent: dismissSparkleCampaignEvent,
  sendPlayEvent,
  hasLocaleSupport
};
